import { render, staticRenderFns } from "./SingleParamTDUsage.vue?vue&type=template&id=08f24201&scoped=true"
import script from "./SingleParamTDUsage.vue?vue&type=script&lang=js"
export * from "./SingleParamTDUsage.vue?vue&type=script&lang=js"
import style0 from "./SingleParamTDUsage.vue?vue&type=style&index=0&id=08f24201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f24201",
  null
  
)

export default component.exports